import i18n from 'i18n';

const { t } = i18n;
const accountsDeletionFaqs = () => [
  { question: t('account_deletion__faq_q1'), answer: t('account_deletion__faq_a1') },
  { question: t('account_deletion__faq_q2'), answer: t('account_deletion__faq_a2') },
  { question: t('account_deletion__faq_q3'), answer: t('account_deletion__faq_a3') },
  { question: t('account_deletion__faq_q4'), answer: t('account_deletion__faq_a4') },
  { question: t('account_deletion__faq_q5'), answer: t('account_deletion__faq_a5') },
  { question: t('account_deletion__faq_q6'), answer: t('account_deletion__faq_a6') },
  { question: t('account_deletion__faq_q7'), answer: t('account_deletion__faq_a7') },
];

export default accountsDeletionFaqs;
